export enum AdminActions {
  BLOCK = 'BLOCK',
  UNBLOCK = 'UNBLOCK',
  RESEND = 'RESEND',
}
